import * as React from 'react';
import { FieldGroupProps } from '../types';
import Field from './Field';
import { useFormContext } from './contexts/form';

const FieldGroup: React.FC<FieldGroupProps> = ({ fieldGroup, setFieldRef }) => {
	const { formData } = useFormContext();

	return (
		<div className="app-calculator__field-group">
			{fieldGroup.section_title && <p className="supertext">{fieldGroup.section_title}</p>}
			{fieldGroup.fields.map((field, index) => {
				return (
					<Field
						field={{ ...field, value: formData[field.id] || '' }}
						key={index}
						// Pass the setFieldRef function to Field
						setFieldRef={setFieldRef}
					/>
				);
			})}
		</div>
	);
};

export default FieldGroup;
